var parkMarker = undefined;
var mainMarker = undefined;
var glocations = [];
var markers = [];
var map;
var bounds;
let click = false;
const filterMarkers = function (event, category) {
    bounds = new google.maps.LatLngBounds();
    let $this = $(event);

    if($this.hasClass('active')) {

        let vilnius_connect = new google.maps.Marker({
            title: main_address,
            position: new google.maps.LatLng(vilnius_connect_coords[0], vilnius_connect_coords[1]),
            map: map,
            optimized: false,
            icon: {
                url: '',
                scaledSize: new google.maps.Size(59, 87),
                anchor: new google.maps.Point(30, 44),
            }
        });
    
        let vilnius = new SnazzyInfoWindow({
            marker: vilnius_connect,
            content: '<img src="assets/svg/markers/vilnius_connect.svg" alt="">',
            showCloseButton: true,
            pointer: false,
            border: false,
            borderRadius: 'unset',
            wrapperClass: 'infoWindow vilnius-connect',
            shadow: false,
            closeWhenOthersOpen: false,
            closeOnMapClick: false,
            callbacks: {
                afterOpen: function() {
                    $(this.getWrapper()).addClass('open');
                }
            }
        });
        
        vilnius.open();

        bounds.extend(vilnius_connect.getPosition());
        bounds.extend(mainMarker.getPosition())
    
        for (let i = 0; i < locations.length; i++) {
            let marker = glocations[i];
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
        }

        map.fitBounds(bounds);
        $('.infoWindow').remove();
        return;
    }

    // const vilnius_connect_path = [
    //     {lat:54.672035,  lng: 25.290356},
    //     {lat: 54.671781,lng: 25.290677},
    //     {lat: 54.670434, lng: 25.288589},
    //     {lat: 54.669992, lng: 25.287530},

    // ]
    let vilnius_connect = new google.maps.Marker({
        title: main_address,
        position: new google.maps.LatLng(vilnius_connect_coords[0], vilnius_connect_coords[1]),
        map: map,
        optimized: false,
        icon: {
            url: '',
            scaledSize: new google.maps.Size(59, 87),
            anchor: new google.maps.Point(30, 44),
        }
    });

    let vilnius = new SnazzyInfoWindow({
        marker: vilnius_connect,
        content: '<img src="assets/svg/markers/vilnius_connect.svg" alt="">',
        showCloseButton: true,
        pointer: false,
        border: false,
        borderRadius: 'unset',
        wrapperClass: 'infoWindow vilnius-connect',
        shadow: false,
        closeWhenOthersOpen: false,
        closeOnMapClick: false,
        callbacks: {
            afterOpen: function() {
                $(this.getWrapper()).addClass('open');
            }
        }
    });

    vilnius.open();

    bounds.extend(vilnius_connect.getPosition());
    bounds.extend(mainMarker.getPosition())

    for (let i = 0; i < locations.length; i++) {
        let marker = glocations[i];

        // If is same category or category not picked
        if (marker.category == category) {
            marker.setVisible(true);
            bounds.extend(marker.getPosition());
        }
        else {
            marker.setVisible(false);
        }
    }
    map.fitBounds(bounds);
    $('.infoWindow').remove();
};

function initMap() {
    if (typeof locations !== 'undefined') {
        bounds = new google.maps.LatLngBounds();
    }

    map = new google.maps.Map(document.getElementById('map'), {
        zoom: parseInt(zoom_level),
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        center: new google.maps.LatLng(mainCoords[0], mainCoords[1]),
        styles: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6ded7"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6ded7"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#cfd4c7"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2ede9"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2ede9"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2ede9"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ccd3d6"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ]
    });

    for (let i = 0; i < locations.length; i++) {
        addMarker(locations[i]);
    }

    //
    let other_path = [
        {lat: 54.66859644770283,lng: 25.275051401354624},
        {lat: 54.668478586903234, lng: 25.276028497220075},
        {lat: 54.668303808962456, lng: 25.276297790133757},
        {lat: 54.66871999603564, lng: 25.27743118874378},
        {lat: 54.669089708685334, lng: 25.2768987587251},
        {lat: 54.669148300752624, lng: 25.27650422226284},
        {lat: 54.669507407279866, lng: 25.276557037846313},
        {lat: 54.66951070400253, lng: 25.2762019046407},
        {lat: 54.669405369241645, lng: 25.275872466432094},
        {lat: 54.66927670157479, lng: 25.275867183090792},
        {lat: 54.669342676767165, lng: 25.27542503090296}
    ]

    let vilnius_connect_path = [
        {lat: 54.67203,lng: 25.290356}, 
        {lat: 54.671781,lng: 25.290677},
        {lat: 54.670434,lng: 25.288589}, 
        {lat: 54.669992,lng: 25.287530}, 
        {lat: 54.669495,lng: 25.286652}, 
        {lat: 54.668660,lng: 25.285625}, 
        {lat: 54.667382,lng: 25.282017}, 
        {lat: 54.666116,lng: 25.273021}, 
        { lat: 54.667171,lng: 25.272536}, 
        {lat: 54.667444,lng: 25.274941}, 
        {lat: 54.670199,lng: 25.283079}, 
        {lat: 54.670025,lng:25.283313}, 
        {lat: 54.670732, lng: 25.285245}, 
        { lat:54.670955,lng: 25.285138}, 
        {lat: 54.671477, lng: 25.287156},
        {lat: 54.67203,lng: 25.290356}
    ]

    const flightPath = new google.maps.Polygon({
        path: vilnius_connect_path,
        strokeColor: "#e1d7cc",
        fillColor: "#e1d7cc",
        fillOpacity: 0.5,
        strokeOpacity: 0,
        strokeWeight: 2,
    });

    flightPath.setMap(map);

    const otherPath1 = new google.maps.Polygon({
        path: other_path,
        strokeColor: "#d3d0c9",
        fillColor: "#d3d0c9",
        fillOpacity: 1,
        strokeOpacity: 0,
        strokeWeight: 2,
    });

    otherPath1.setMap(map);

    parkMarker = new google.maps.Marker({
        title: main_address,
        position: new google.maps.LatLng(parkCoords[0], parkCoords[1]),
        map: map,
        optimized: false,
        icon: {
            url: 'assets/svg/markers/park.svg',
            scaledSize: new google.maps.Size(42, 72),
            anchor: new google.maps.Point(21, 36),
        }
    });

    new SnazzyInfoWindow({
        marker: parkMarker,
        content: '<a href="'+ park_link +'" ' +  park_pdf + ' class="title special" style="display: flex;align-items:center;">'+park_address.split('|')[0]+'<span class="icon-download"><svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.89 14.11"><defs><style>.cls-1{fill:#ede8e5;}</style></defs><path class="cls-1" d="M4.94,0c-.36,0-.66,.29-.66,.66V11.87l-3.17-3.17c-.26-.26-.67-.26-.92,0s-.26,.67,0,.92l4.29,4.29c.13,.13,.29,.19,.47,.19s.34-.06,.47-.19l4.29-4.29c.26-.26,.26-.67,0-.92s-.67-.26-.92,0l-3.17,3.17V.65c0-.36-.29-.65-.66-.65Z"/></svg></span></a>',
        showCloseButton: true,
        pointer: false,
        border: false,
        borderRadius: 'unset',
        wrapperClass: 'infoWindow main',
        shadow: false,
        closeWhenOthersOpen: true,
        callbacks: {
            afterOpen: function() {
                $(this.getWrapper()).addClass('open');
            }
        }
    });


    mainMarker = new google.maps.Marker({
        title: main_address,
        position: new google.maps.LatLng(mainCoords[0], mainCoords[1]),
        map: map,
        optimized: false,
        icon: {
            url: 'assets/svg/markers/aa.svg',
            scaledSize: new google.maps.Size(59, 87),
            anchor: new google.maps.Point(30, 44),
        }
    });

    mainMarker.setZIndex(100)

    new SnazzyInfoWindow({
        marker: mainMarker,
        content: '<div class="title">'+main_address+'</div>',
        showCloseButton: true,
        pointer: false,
        border: false,
        borderRadius: 'unset',
        wrapperClass: 'infoWindow main',
        shadow: false,
        closeWhenOthersOpen: true,
        callbacks: {
            afterOpen: function() {
                $(this.getWrapper()).addClass('open');
            }
        }
    });



    bounds.extend(mainMarker.getPosition());

    let vilnius_connect = new google.maps.Marker({
        title: main_address,
        position: new google.maps.LatLng(vilnius_connect_coords[0], vilnius_connect_coords[1]),
        map: map,
        optimized: false,
        icon: {
            url: '',
            scaledSize: new google.maps.Size(59, 87),
            anchor: new google.maps.Point(30, 44),
        }
    });

    let vilnius = new SnazzyInfoWindow({
        marker: vilnius_connect,
        content: '<img src="assets/svg/markers/vilnius_connect.svg" alt="">',
        showCloseButton: true,
        pointer: false,
        border: false,
        borderRadius: 'unset',
        wrapperClass: 'infoWindow vilnius-connect',
        shadow: false,
        closeWhenOthersOpen: false,
        closeOnMapClick: false,
        callbacks: {
            afterOpen: function() {
                $(this.getWrapper()).addClass('open');
            }
        }
    });

    vilnius.open();

    bounds.extend(vilnius_connect.getPosition());

  //  filterMarkers(1);
  map.zp
}

function addMarker(marker) {
    let category = marker.category;
    let title = marker.title;
    let titleIndentify = marker.title+marker.car+marker.walk;
    let pos = new google.maps.LatLng(marker.lat, marker.lng);
    let icon_m = 'assets/svg/markers/'+marker.category+'.svg';
    let markerscaledSize;
    let markerAnchor;

    if($(window).width() < 768){
        markerscaledSize = new google.maps.Size(42, 42);
        markerAnchor = new google.maps.Point(21, 21);
    }else{
        markerscaledSize = new google.maps.Size(42, 42);
        markerAnchor = new google.maps.Point(21, 21);
    }

    let marker1 = new google.maps.Marker({
        titleIndentify: titleIndentify.replace(/['"]+/g, ''),
        title: title,
        position: pos,
        category: category,
        time: marker.time,
        map: map,
        optimized: false,
        icon: {
            url: icon_m,
            scaledSize: markerscaledSize,
            anchor: markerAnchor
        }
    });

    new SnazzyInfoWindow({
        marker: marker1,
        content: '<div class="time">'+marker.time+'</div><div class="line"></div><div class="title">'+marker.title+'</div>',
        showCloseButton: true,
        pointer: false,
        border: false,
        borderRadius: 'unset',
        wrapperClass: 'infoWindow',
        shadow: false,
        closeWhenOthersOpen: true,
        callbacks: {
            afterOpen: function() {
                $(this.getWrapper()).addClass('open');
            }
        }
    });

    glocations.push(marker1);
    markers.push(marker1);
}


$('.map-categories a').click(function(e){
    e.preventDefault();
    let $this  =  $(this);
    let cl = $this.hasClass('active');
    $('.map-categories a').removeClass('active');
    cl ?   $this.removeClass('active') :  $this.addClass('active');
});

if(typeof locations !== 'undefined'){
    initMap();
}